import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { Img } from "./Img";
import { WatchNowButton } from "./WatchNowButton";
import { CardTrailerButton } from "./TrailerButtons";
import { FALLBACK_POSTER, posterUrl, year } from "../lib/api";

export const MovieCard = ({ movie, testPrefix, className = "" }) => {
  const media = movie.media_type || "movie";
  const prefix = testPrefix || `${media}-card`;
  const to = `/${media}/${movie.id}`;
  return (
    <div data-testid={`${prefix}-${movie.id}`} className={`movie-card group relative ${className}`}>
      <div className="relative aspect-[2/3] overflow-hidden rounded-xl bg-[#121212] ring-1 ring-white/5 transition-shadow duration-300 group-hover:ring-[#D4AF37]/50">
        <Link to={to} data-testid={`${prefix}-link-${movie.id}`} aria-label={movie.title}>
          <Img
            src={posterUrl(movie.poster_path)}
            fallback={FALLBACK_POSTER}
            alt={movie.title}
            className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
          />
          <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
        </Link>
        <div className="pointer-events-none absolute left-2 top-2 flex items-center gap-1.5">
          <span className="flex items-center gap-1 rounded-full bg-black/70 px-2 py-1 text-[11px] font-medium text-[#D4AF37] backdrop-blur-md">
            <Star className="h-3 w-3 fill-current" /> {Number(movie.vote_average || 0).toFixed(1)}
          </span>
          {media === "tv" && (
            <span data-testid={`${prefix}-tv-badge-${movie.id}`} className="rounded-md bg-[#D4AF37] px-1.5 py-0.5 text-[10px] font-bold tracking-widest text-black">
              TV
            </span>
          )}
        </div>
        <div className="absolute inset-x-0 bottom-0 hidden translate-y-3 justify-center p-3 opacity-0 transition-[opacity,transform] duration-300 group-hover:translate-y-0 group-hover:opacity-100 md:flex">
          <WatchNowButton item={movie} size="sm" testId={`${prefix}-watch-now-${movie.id}`} />
        </div>
        <CardTrailerButton item={movie} />
      </div>
      <Link to={to} className="mt-3 block" tabIndex={-1}>
        <h3 className="line-clamp-1 font-display text-[15px] font-semibold text-neutral-100 transition-colors duration-300 group-hover:text-[#D4AF37]">
          {movie.title}
        </h3>
        <p className="mt-0.5 text-xs text-neutral-500">{year(movie.release_date)}</p>
      </Link>
    </div>
  );
};

export const MovieCardSkeleton = () => (
  <div>
    <div className="skeleton aspect-[2/3] rounded-xl" />
    <div className="skeleton mt-3 h-4 w-3/4 rounded" />
    <div className="skeleton mt-2 h-3 w-1/4 rounded" />
  </div>
);
